export interface UpdateBudgetRequest {
  year: string
  branchCode: string
  departmentCode: string
  item: string
  equipType: string
  info: {
    id: number
    traderCode: string
    price: string
    orderPrice: string
    acceptPrice: string
    revision: number
  }[]
}

export function UpdateBudgetRequestToJSON(value: UpdateBudgetRequest): any {
  return {
    year: value.year !== '' ? value.year : undefined,
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    department_code:
      value.departmentCode !== '' ? value.departmentCode : undefined,
    item: value.item !== '' ? value.item : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined,
    info:
      value.info.length > 0
        ? value.info.map(item => {
            return {
              id: item.id !== 0 ? item.id : 0,
              trader_code: item.traderCode !== '' ? item.traderCode : undefined,
              price: item.price !== '' ? item.price : undefined,
              order_price: item.orderPrice !== '' ? item.orderPrice : undefined,
              accept_price:
                item.acceptPrice !== '' ? item.acceptPrice : undefined,
              revision: item.revision !== 0 ? item.revision : 0
            }
          })
        : []
  }
}
